module.exports = __webpack_public_path__ + "img/MEDIA027.766f1bb5.jpg";